import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote, IonToast, useIonRouter
} from '@ionic/react';

import {RouteComponentProps, withRouter} from 'react-router-dom';
import { logOutOutline, logOutSharp, codeSlashOutline, codeSlashSharp } from 'ionicons/icons';
import './menu.css';
import { CREWHUB_ROUTES, NavigationLink } from '@models';
import {useSession, useStorage} from '@hooks';
import { useState } from 'react';
import CrewHubLogo from '@components/lib/crew-hub-logo/crew-hub-logo';

export interface MenuProps extends RouteComponentProps {
  links: NavigationLink[];
  redirectToOnSignout: string;
}

function Menu(props: MenuProps) {
  const router = useIonRouter();
  const { logout } = useSession();
  const [tapCount, setTapCount] = useState(0);
  const [devModeHidden, setDevModeHidden] = useState(true);
  const [toastOpen, setToastOpen] = useState(false);
  const storage = useStorage();

  storage.get('devMode').then((value) => {
    setDevModeHidden(value !== 'true');
  });

  const handleSignOutRedirect = () => {
    router.push(props.redirectToOnSignout);
  };

  const handleLogout = async () => {
    handleSignOutRedirect();
    try {
      await logout();
    } catch {
      console.log('user not signed in');
    }
  };

  const handleIconTap = () => {
    const newCount = tapCount + 1;
    setTapCount(newCount);
    
    if (newCount >= 10) {
      storage.set('devMode', 'true');
      // Reset counter
      setTapCount(0);
      // Optional: Add some feedback
      setToastOpen(true);
      setDevModeHidden(false);
    }
  };

  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent>
        <IonList>
          <IonListHeader onClick={handleIconTap} style={{marginBottom: '8px'}}>
            <CrewHubLogo pxWidth={'150px'} pxHeight={'18px'}/>
          </IonListHeader>
          <IonNote>Menu</IonNote>
          <IonMenuToggle autoHide={false}>
            {props.links.map((link, index) => {
              return (
                <IonItem
                  key={index}
                  className={router.routeInfo.pathname === link.url ? 'selected' : ''}
                  routerLink={link.url}
                  routerDirection="none"
                  lines="none"
                  detail={false}
                >
                  <IonIcon
                    slot="start"
                    ios={link.iosIcon}
                    md={link.mdIcon}
                    color="light"
                  />
                  <IonLabel color="light">{link.title}</IonLabel>
                </IonItem>
              );
            })}

            <IonItem
              routerLink={CREWHUB_ROUTES.FLIGHTS}
              routerDirection="none"
              lines="none"
              detail={false}
              hidden={devModeHidden}
            >
              <IonIcon
                slot="start"
                ios={codeSlashOutline}
                md={codeSlashSharp}
                color="light"
              />
              <IonLabel color="light">Flights</IonLabel>
            </IonItem>

            <IonItem
              onClick={() => handleLogout()}
              routerLink={CREWHUB_ROUTES.LOGIN}
              routerDirection="none"
              lines="none"
              detail={false}
            >
              <IonIcon
                slot="start"
                ios={logOutOutline}
                md={logOutSharp}
                color="light"
              />
              <IonLabel color="light">Sign Out</IonLabel>
            </IonItem>
          </IonMenuToggle>
        </IonList>

        <IonToast 
          isOpen={toastOpen}
          message="Developer mode activated!"
          onDidDismiss={() => setToastOpen(false)}
          duration={5000}
        ></IonToast>
      </IonContent>
    </IonMenu>
  );
}

export default withRouter(Menu);
